module.exports = __webpack_public_path__ + "static/media/Niveau_elN7_4_841953.8efa9167.png";